import {
  WorkflowTemplateValues,
  WorkflowConfiguration,
  STEP_COMPLETION_ACTION,
  StepCompletionAction,
} from 'models/WorkflowConfiguration';

export const getIsCompletionAction = (action: StepCompletionAction) =>
  action === STEP_COMPLETION_ACTION.ASK_PROGRESSION_QUESTION;

type RulesValues = Pick<
  WorkflowTemplateValues,
  'specificRules' | 'maxCapacity'
>;

export const extractRulesUpdateValues = (
  { specificRules, maxCapacity }: RulesValues,
  initialValues: RulesValues,
) => {
  const updateValues: Partial<WorkflowConfiguration> = {};

  if (
    !!specificRules?.automaticallySendNDA !==
    !!initialValues.specificRules?.automaticallySendNDA
  )
    updateValues.automaticallySendNDA = !!specificRules?.automaticallySendNDA;

  // The input hands back a string, so "5" and 5 count as unchanged.
  if (`${maxCapacity ?? ''}` !== `${initialValues.maxCapacity ?? ''}`)
    updateValues.maxCapacity = maxCapacity;

  return updateValues;
};

export const extractQuestionUpdateValues = (
  values: Pick<
    WorkflowTemplateValues,
    'completionAction' | 'progressionQuestion'
  >,
  isLastStage = false,
) => {
  const updateValues: Partial<WorkflowConfiguration> = {};

  const { completionAction, progressionQuestion } = values || {};

  updateValues.completionAction = completionAction;

  if (getIsCompletionAction(completionAction)) {
    updateValues.progressionQuestion = {
      ...progressionQuestion,
      answers: progressionQuestion.answers
        .filter(({ text }) => !!text)
        // No answer moves a lead out of the last stage.
        .map((answer) =>
          isLastStage ? { ...answer, advancesLead: false } : answer,
        ),
    };
  }

  return updateValues;
};
